import OImage from 'components/reusable/OImage';
import OInputField from 'components/reusable/OInputField';
import useToastContext from 'hooks/useToastContext';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { apiGet, apiPost } from 'utils/apiFetch';
import apiPath from 'utils/apiPath';
import photoClose from '../../assets/images/photo_close.png';
import ReactQuill from 'react-quill';
import helpers from 'utils/helpers';

const AddCommunity = () => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const navigate = useNavigate();
  const [selectedCommunity, setSelectedCommunity] = useState();
  const [communityData, setCommunityData] = useState([]);
  const [attractions, setAttractions] = useState([
    { title: '', titleAr: '', icon: '' },
  ]);
  const [FAQ, setFAQ] = useState([
    { question: '', answer: '', questionAr: '', answerAr: '' },
  ]);
  const [feature, setFeature] = useState([{ title: '', titleAr: '' }]);
  const [communityIcon, setCommunityIcon] = useState([]);
  const [banner, setBanner] = useState([]);
  const [isShowHome, setIsShowHome] = useState(false);
  const [imagGallery, setImagGallery] = useState([]);
  const [description, setDescription] = useState('');
  const [descriptionAr, setDescriptionAr] = useState('');
  const [descriptionSecond, setDescriptionSecond] = useState('');
  const [descriptionSecondAr, setDescriptionSecondAr] = useState('');
  const [description3, setDescription3] = useState('');
  const [description3Ar, setDescription3Ar] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [metaDescriptionAr, setMetaDescriptionAr] = useState('');
  const {
    register,
    setValue,
    // watch,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onChange', shouldFocusError: true, defaultValues: {} });

  const communityIconRef = useRef();
  const bannerRef = useRef();
  const imagGalleryRef = useRef();
  const iconRef = useRef();

  useEffect(() => {
    getCommunities();
  }, []);

  const getCommunities = async () => {
    try {
      const payload = {};
      const path = helpers.isSaudi()
        ? `${apiPath.allCommunities}?type=saudi`
        : apiPath.allCommunities;
      const result = await apiGet(path, payload);
      const records = result?.data?.results;
      setCommunityData(records);
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message);
    }
  };

  const handleSubmitForm = async (data) => {
    let formData = new FormData();
    formData.append('communityId', selectedCommunity);
    formData.append('subTitle', data?.subTitle);
    formData.append('subTitleAr', data?.subTitleAr);
    formData.append('shortDescription', data?.shortDescription);
    formData.append('shortDescriptionAr', data?.shortDescriptionAr);
    formData.append('ctaTitle', data?.ctaTitle);
    formData.append('ctaTitleAr', data?.ctaTitleAr);
    formData.append('ctaSubtitle', data?.ctaSubtitle);
    formData.append('ctaSubtitleAr', data?.ctaSubtitleAr);
    formData.append('communityIcon', communityIcon[0]);
    formData.append('banner', banner[0]);
    // for (let i = 0; i < feature?.length; i++) {
    //   formData.append("features", feature[i]?.title);
    // }
    // for (let i = 0; i < feature?.length; i++) {
    formData.append('features', JSON.stringify(feature));
    // }
    for (let i = 0; i < imagGallery?.length; i++) {
      formData.append('imageGallery', imagGallery[i]);
    }

    for (let i = 0; i < attractions?.length; i++) {
      formData.append('attractionTitles', attractions[i]?.title);
    }
    for (let i = 0; i < attractions?.length; i++) {
      formData.append('attractionTitlesAr', attractions[i]?.titleAr);
    }

    for (let i = 0; i < attractions?.length; i++) {
      formData.append('attractionIcons', attractions[i]?.icon);
    }
    formData.append('faq', JSON.stringify(FAQ));
    formData.append('description2', descriptionSecond);
    formData.append('description3', description3);
    formData.append('description', description);
    formData.append('description2Ar', descriptionSecondAr);
    formData.append('description3Ar', description3Ar);
    formData.append('descriptionAr', descriptionAr);

    formData.append('metaTitle', data?.metaTitle);
    formData.append('metaTitleAr', data?.metaTitleAr);
    formData.append('metaDescription', metaDescription);
    formData.append('metaDescriptionAr', metaDescriptionAr);
    formData.append('keyword', data?.keyword);
    formData.append('keywordAr', data?.keywordAr);

    formData.append('isShowHome', isShowHome);

    try {
      const { data: response } = await apiPost(
        apiPath.discoverCommunities,
        formData
      );

      if (response?.success) {
        notification.success(response?.message);
        navigate('/community');
      } else {
        notification.error(response?.message);
      }
    } catch (error) {
      notification.error(error?.message);
    }
  };

  const removePhotos = async (index, type) => {
    switch (type) {
      case 'imagGallery':
        setImagGallery((prev) => {
          return prev?.filter((res) => res !== index);
        });
        break;
      case 'communityIcon':
        setCommunityIcon((prev) => {
          return prev?.filter((res) => res !== index);
        });
        break;
      case 'banner':
        setBanner((prev) => {
          return prev?.filter((res) => res !== index);
        });
        break;

      default:
        break;
    }
  };

  const handlePhotosChange = (e, name) => {
    const files = e.target.files;
    let images = [];
    for (let i = 0; i < files?.length; i++) {
      images.push(files[i]);
    }
    switch (name) {
      case 'imagGallery':
        setImagGallery(...imagGallery, images);
        break;

      case 'communityIcon':
        setCommunityIcon(images);
        break;

      case 'banner':
        setBanner(images);
        break;

      default:
        break;
    }
  };

  const addmore = (type) => {
    switch (type) {
      case 'attractions':
        setAttractions([...attractions, { title: '', titleAr: '', icon: '' }]);
        break;

      case 'feature':
        setFeature([...feature, { title: '', titleAr: '' }]);
        break;

      case 'FAQ':
        setFAQ([...FAQ, { question: '', answer: '' }]);
        break;

      default:
        break;
    }
  };

  const deleteMore = (type, index) => {
    switch (type) {
      case 'attraction':
        setAttractions(
          attractions?.filter((attr, tempIndex) => tempIndex !== index)
        );
        break;

      case 'feature':
        setFeature(feature?.filter((feat, tempIndex) => tempIndex !== index));
        break;

      case 'FAQ':
        setFAQ(FAQ?.filter((faq, tempIndex) => tempIndex !== index));
        break;

      default:
        break;
    }
  };

  return (
    <div className="basic_info px-4 ">
      <form
        className="py-4"
        onSubmit={handleSubmit(handleSubmitForm, (submit) => {})}
      >
        <div className="">
          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              <label
                for="projectId"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                {t('SELECT_COMMUNITY')}
              </label>
              <select
                name="projectId"
                id="projectId"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder={t('SELECT_COMMUNITY')}
                onChange={(e) => setSelectedCommunity(e.target.value)}
                value={selectedCommunity}
              >
                <option value="">{t('SELECT_COMMUNITY')}</option>
                {communityData.map((community) => {
                  return (
                    <option value={community._id}>{community.name}</option>
                  );
                })}
              </select>
            </div>

            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="shortDescription"
                  inputLabel={<>{t('O_SHORT_DESCRIPTION')}</>}
                  type="text"
                  register={register('shortDescription', {
                    required: 'Please enter short description',
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="shortDescriptionAr"
                  inputLabel={<>{t('O_SHORT_DESCRIPTION_AR')}</>}
                  type="text"
                  register={register('shortDescriptionAr', {
                    required: 'Please enter short description',
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="ctaTitle"
                  inputLabel={<>{t('O_CTA_TITLE')}</>}
                  type="text"
                  register={register('ctaTitle', {
                    required: 'Please enter cta title',
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="ctaTitleAr"
                  inputLabel={<>{t('O_CTA_TITLE_AR')}</>}
                  type="text"
                  register={register('ctaTitleAr', {
                    required: 'Please enter cta title',
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="ctaSubtitle"
                  inputLabel={<>{t('O_CTA_SUBTITLE')}</>}
                  type="text"
                  register={register('ctaSubtitle', {
                    required: 'Please enter cta subtitle',
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="ctaSubtitleAr"
                  inputLabel={<>{t('O_CTA_SUBTITLE_AR')}</>}
                  type="text"
                  register={register('ctaSubtitleAr', {
                    required: 'Please enter cta subtitle',
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="subTitle"
                  inputLabel={<>{t('O_SUBTITLE')}</>}
                  type="text"
                  register={register('subTitle', {
                    required: 'Please enter sub title',
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="subTitleAr"
                  inputLabel={<>{t('SUB_TITLE_AR')}</>}
                  type="text"
                  register={register('subTitleAr', {
                    required: 'Please enter sub title',
                  })}
                  errors={errors}
                />
              </label>
            </div>

            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="metaTitle"
                  inputLabel={<>{t('STATIC_TITLE')}</>}
                  type="text"
                  register={register('metaTitle')}
                  errors={errors}
                />
              </label>
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="metaTitleAr"
                  inputLabel={<>{t('META_TITLE_AR')}</>}
                  type="text"
                  register={register('metaTitleAr')}
                  errors={errors}
                />
              </label>
            </div>

            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="keyword"
                  inputLabel={<>{t('KEYWORD')}</>}
                  type="text"
                  register={register('keyword')}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="keywordAr"
                  inputLabel={<>{t('KEYWORD_AR')}</>}
                  type="text"
                  register={register('keywordAr')}
                  errors={errors}
                />
              </label>
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('STATIC_DESCRIPTION')}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <ReactQuill
                  theme="snow"
                  value={metaDescription}
                  onChange={setMetaDescription}
                />
              </div>
            </div>
            <div className="mb-3 ">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('META_DESCRIPTION_AR')}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <ReactQuill
                  theme="snow"
                  value={metaDescriptionAr}
                  onChange={setMetaDescriptionAr}
                />
              </div>
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('OFFERS_DESCRIPTION')}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <ReactQuill
                  theme="snow"
                  value={description}
                  onChange={setDescription}
                />
              </div>
            </div>
            <div className="mb-3 ">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('DESCRIPTION_AR')}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <ReactQuill
                  theme="snow"
                  value={descriptionAr}
                  onChange={setDescriptionAr}
                />
              </div>
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-1 gap-4">
            <h4 className="text-lg font-semibold py-3">
              {t('COMMUNITY_ICON')}
            </h4>
            <div className="photo_list flex flex-wrap gap-5">
              <div
                className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
                onClick={() => communityIconRef?.current?.click()}
              >
                <div className="text-center">
                  <img
                    src="../images/uploadimg.png"
                    className="m-auto"
                    alt=""
                  />
                  <strong className="my-2 block text-xl">
                    {t('ADD_PHOTO')}
                  </strong>
                  <input
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    name="communityIcon"
                    ref={communityIconRef}
                    onChange={(e) => handlePhotosChange(e, 'communityIcon')}
                    className="hidden"
                  />
                </div>
              </div>
              {/* <div className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer">
                <input
                  type="file"
                  accept="image/png, image/jpg, image/jpeg, image/svg+xml"
                  name="communityIcon"
                  // ref={photosRef}
                  onChange={(e) => handlePhotosChange(e, "communityIcon")}
                />
              </div> */}

              {communityIcon?.length > 0 && (
                <div
                  style={{ cursor: 'move' }}
                  className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                >
                  <figure className="w-full h-full">
                    <OImage
                      src={
                        typeof communityIcon === 'object'
                          ? URL.createObjectURL(communityIcon[0])
                          : communityIcon
                      }
                      fallbackUrl="/images/user.png"
                      className="w-full h-full object-cover"
                      alt=""
                    />
                  </figure>

                  <button
                    type="button"
                    className="absolute top-[10px] right-[10px]"
                    onClick={() =>
                      removePhotos(communityIcon[0], 'communityIcon')
                    }
                  >
                    <img src={photoClose} alt="" />
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-1 gap-4">
            <h4 className="text-lg font-semibold py-3">
              {t('COMMUNITY_BANNER')}
            </h4>
            <div className="photo_list flex flex-wrap gap-5">
              <div
                className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
                onClick={() => bannerRef?.current?.click()}
              >
                <div className="text-center">
                  <img
                    src="../images/uploadimg.png"
                    className="m-auto"
                    alt=""
                  />
                  <strong className="my-2 block text-xl">
                    {t('ADD_PHOTO')}
                  </strong>
                  <input
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    name="banner"
                    ref={bannerRef}
                    onChange={(e) => handlePhotosChange(e, 'banner')}
                    className="hidden"
                  />
                </div>
              </div>

              {banner?.length > 0 && (
                <div
                  style={{ cursor: 'move' }}
                  className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                >
                  <figure className="w-full h-full">
                    <OImage
                      src={
                        typeof banner === 'object'
                          ? URL.createObjectURL(banner[0])
                          : banner
                      }
                      fallbackUrl="/images/user.png"
                      className="w-full h-full object-cover"
                      alt=""
                    />
                  </figure>

                  <button
                    type="button"
                    className="absolute top-[10px] right-[10px]"
                    onClick={() => removePhotos(banner[0], 'banner')}
                  >
                    <img src={photoClose} alt="" />
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-1 gap-4">
            <h4 className="text-lg font-semibold py-3">{t('IMAGE_GALLERY')}</h4>
            <div className="photo_list flex flex-wrap gap-5">
              <div
                className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer"
                onClick={() => imagGalleryRef?.current?.click()}
              >
                <div className="text-center">
                  <img
                    src="../images/uploadimg.png"
                    className="m-auto"
                    alt=""
                  />
                  <strong className="my-2 block text-xl">
                    {t('ADD_PHOTO')}
                  </strong>
                  <input
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    name="imagGallery"
                    ref={imagGalleryRef}
                    onChange={(e) => handlePhotosChange(e, 'imagGallery')}
                    className="hidden"
                    multiple
                  />
                </div>
              </div>

              {imagGallery?.length > 0 &&
                imagGallery?.map((item, index) => (
                  <div
                    key={index}
                    style={{ cursor: 'move' }}
                    className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                  >
                    <figure className="w-full h-full">
                      <OImage
                        src={
                          typeof item === 'object'
                            ? URL.createObjectURL(item)
                            : item
                        }
                        fallbackUrl="/images/user.png"
                        className="w-full h-full object-cover"
                        alt=""
                      />
                    </figure>

                    <button
                      type="button"
                      className="absolute top-[10px] right-[10px]"
                      onClick={() => removePhotos(item, 'imagGallery')}
                    >
                      <img src={photoClose} alt="" />
                    </button>
                  </div>
                ))}
            </div>
          </div>

          <div className="attraction  mt-5 mb-5">
            <h4 className="text-lg font-semibold py-3">{t('ATTRACTION')}</h4>
            {attractions &&
              attractions?.length &&
              attractions?.map((item, index) => (
                <div className="grid grid-rows-1 grid-cols-4 gap-4" key={index}>
                  <div className="mb-3">
                    <label className="block">
                      <span className="block text-sm font-medium mb-2">
                        {t('O_TITLE')}
                      </span>
                      <input
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="title"
                        value={item?.title}
                        type="text"
                        onChange={(e) => {
                          setAttractions(
                            attractions?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  title: e.target.value,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                        errors={errors}
                      />
                    </label>
                  </div>
                  <div className="mb-3">
                    <label className="block">
                      <span className="block text-sm font-medium mb-2">
                        {t('TITLE_AR')}
                      </span>
                      <input
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="titleAr"
                        value={item?.titleAr}
                        type="text"
                        onChange={(e) => {
                          setAttractions(
                            attractions?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  titleAr: e.target.value,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                        errors={errors}
                      />
                    </label>
                  </div>
                  <div className="mb-3">
                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      {t('O_ICON')}
                    </label>

                    <div className="photo_list flex flex-wrap gap-5">
                      <input
                        type="file"
                        accept="image/png, image/jpg, image/jpeg"
                        name="icon"
                        onChange={(e) => {
                          setAttractions(
                            attractions?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  icon: e.target.files[0],
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                      />

                      {item?.icon && (
                        <div
                          style={{ cursor: 'move' }}
                          className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                        >
                          <figure className="w-full h-full">
                            <OImage
                              src={
                                typeof item?.icon === 'object'
                                  ? URL.createObjectURL(item?.icon)
                                  : item?.icon
                              }
                              fallbackUrl="/images/user.png"
                              className="w-full h-full object-cover"
                              alt=""
                            />
                          </figure>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex-end items-center text-end">
                    <button
                      type="button"
                      className="ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]"
                      onClick={() => deleteMore('attraction', index)}
                    >
                      <span className=" text-[#222]  text-lg " title="Close">
                        ×
                      </span>
                    </button>
                  </div>
                </div>
              ))}
            <button
              className="text-blue-400 mt-5"
              type="button"
              onClick={() => addmore('attractions')}
            >
              {t('ADD_MORE')}
            </button>
          </div>

          <div className="grid grid-rows-1 grid-cols-3 gap-4rounded-sm">
            {feature &&
              feature.map((item, index) => (
                <>
                  {' '}
                  <div className="mb-3">
                    <label className="block">
                      <span className="block text-sm font-medium mb-2">
                        {t('FEATURES')}
                      </span>
                      <input
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="title"
                        value={item?.title}
                        type="text"
                        onChange={(e) => {
                          setFeature(
                            feature?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  title: e.target.value,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                      />
                    </label>
                  </div>
                  <div className="mb-3">
                    <label className="block">
                      <span className="block text-sm font-medium mb-2">
                        {t('FEATURES_AR')}
                      </span>
                      <input
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="titleAr"
                        value={item?.titleAr}
                        type="text"
                        onChange={(e) => {
                          setFeature(
                            feature?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  titleAr: e.target.value,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                      />
                    </label>
                  </div>
                  <div className="flex-end items-center text-end">
                    <button
                      type="button"
                      className="ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]"
                      onClick={() => deleteMore('feature', index)}
                    >
                      <span className=" text-[#222]  text-lg " title="Close">
                        ×
                      </span>
                    </button>
                  </div>
                </>
              ))}
            <button
              className="text-blue-400 mt-5 mb-5 text-start"
              type="button"
              onClick={() => addmore('feature')}
            >
              {t('ADD_MORE')}
            </button>
          </div>

          <div className="attraction  mt-5 mb-5">
            <h4 className="text-lg font-semibold py-3">{t('FAQ')}</h4>
            {FAQ &&
              FAQ?.length &&
              FAQ?.map((item, index) => (
                <div className="grid grid-rows-1 grid-cols-2 gap-4" key={index}>
                  <div className="mb-3">
                    <label className="block">
                      <span className="block text-sm font-medium mb-2">
                        {t('QUESTION')}
                      </span>
                      <input
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="question"
                        value={item?.question}
                        type="text"
                        onChange={(e) => {
                          setFAQ(
                            FAQ?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  question: e.target.value,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                        errors={errors}
                      />
                    </label>
                  </div>
                  <div className="mb-3">
                    <label className="block">
                      <span className="block text-sm font-medium mb-2">
                        {t('QUESTION_AR')}
                      </span>
                      <input
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="questionAr"
                        value={item?.questionAr}
                        type="text"
                        onChange={(e) => {
                          setFAQ(
                            FAQ?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  questionAr: e.target.value,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                        errors={errors}
                      />
                    </label>
                  </div>
                  <div className="mb-3">
                    <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      {t('ANSWER')}
                    </p>
                    <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                      <ReactQuill
                        theme="snow"
                        value={item?.answer ?? ''}
                        onChange={(e) => {
                          setFAQ(
                            FAQ?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  answer: e,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      {t('ANSWER_AR')}
                    </p>
                    <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                      <ReactQuill
                        theme="snow"
                        value={item?.answerAr ?? ''}
                        onChange={(e) => {
                          setFAQ(
                            FAQ?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  answerAr: e,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                      />
                    </div>
                    {/* <label className="block">
                      <span className="block text-sm font-medium mb-2">
                        {t("ANSWER_AR")}
                      </span>
                      <input
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        name="answerAr"
                        value={item?.answerAr}
                        type="text"
                        onChange={(e) => {
                          setFAQ(
                            FAQ?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  answerAr: e.target.value,
                                };
                              } else {
                                return res;
                              }
                            })
                          );
                        }}
                        errors={errors}
                      />
                    </label> */}
                  </div>
                  <div className="flex-end items-center text-end">
                    <button
                      type="button"
                      className="ml-3  text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]"
                      onClick={() => deleteMore('FAQ', index)}
                    >
                      <span className=" text-[#222]  text-lg " title="Close">
                        ×
                      </span>
                    </button>
                  </div>
                </div>
              ))}
            <button
              className="text-blue-400 mt-5"
              type="button"
              onClick={() => addmore('FAQ')}
            >
              {t('ADD_MORE')}
            </button>
          </div>

          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('DESCRIPTION_SECOND')}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <ReactQuill
                  theme="snow"
                  value={descriptionSecond}
                  onChange={setDescriptionSecond}
                />
              </div>
            </div>
            <div className="mb-3 ">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('DESCRIPTION_SECOND_AR')}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <ReactQuill
                  theme="snow"
                  value={descriptionSecondAr}
                  onChange={setDescriptionSecondAr}
                />
              </div>
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('DESCRIPTION_THIRD')}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <ReactQuill
                  theme="snow"
                  value={description3}
                  onChange={setDescription3}
                />
              </div>
            </div>
            <div className="mb-3 ">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('DESCRIPTION_THIRD_AR')}
              </p>
              <div className="shadow-md mb-5 rounded-[4px]  hover:outline-none focus:outline-none hover:border-yellow-500 ">
                <ReactQuill
                  theme="snow"
                  value={description3Ar}
                  onChange={setDescription3Ar}
                />
              </div>
            </div>
          </div>

          <div className="grid grid-rows-1 grid-cols-1 gap-4">
            <div className="mb-3 ">
              <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                {t('SHOW_HOME')}
              </p>
              <label
                className="inline-flex relative items-center cursor-pointer"
                title={t('SHOW_HOME')}
                // title={`${
                //   item?.status === 'yes' ? 'Yes' : 'No'
                // }`}
              >
                <input
                  type="checkbox"
                  // value="yes"
                  className="sr-only peer"
                  checked={isShowHome}
                  id="isMain"
                  name="isMain"
                  onChange={(e) => setIsShowHome(e.target.checked)}
                />
                <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
              </label>
            </div>
          </div>

          <div className="border-t mt-10 py-10 text-center">
            <button className="bg-lime-500 hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-md px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150">
              {t('SAVE')}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddCommunity;
